var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56912 4.37573C3.68073 4.37573 1.72537 8.77529 1.72537 8.77529C1.72537 8.77529 3.68073 13.1748 8.56912 13.1748C13.4575 13.1748 15.4129 8.77529 15.4129 8.77529C15.4129 8.77529 13.4575 4.37573 8.56912 4.37573Z",
    stroke: "black",
    strokeWidth: 0.977679,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5691 11.2194C9.919 11.2194 11.0133 10.1251 11.0133 8.77525C11.0133 7.42536 9.919 6.33105 8.5691 6.33105C7.21921 6.33105 6.12491 7.42536 6.12491 8.77525C6.12491 10.1251 7.21921 11.2194 8.5691 11.2194Z",
    stroke: "black",
    strokeWidth: 0.977679,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.c89e97d003aaa7d9ccf88b7e83cf8448.svg";
export { ForwardRef as ReactComponent };